"use strict";

$(document).ready(function () {
  cookies();
});

function cookies() {
  if ($('.gdpr_block').length > 0) {
    setTimeout(function () {
      if (!$.cookie('cookie-policy')) {
        $('.gdpr_block').removeClass('hide');
      }
    }, 3000);
    $('.gdpr_block .acceptance button').on('click', function () {
      $('.gdpr_block').addClass('hide');
      var d = new Date();
      d.setTime(d.getTime() + 360 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = "cookie-policy=agree;" + expires + ";path=/";
      $(this).closest('.gdpr_block').addClass('hide');
    });
  }
}